import { render, staticRenderFns } from "./facet-route-info.vue?vue&type=template&id=2dc527ba&scoped=true"
import script from "./facet-route-info.ts?vue&type=script&lang=ts&external"
export * from "./facet-route-info.ts?vue&type=script&lang=ts&external"
import style0 from "./facet-route-info.scss?vue&type=style&index=0&id=2dc527ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc527ba",
  null
  
)

export default component.exports